import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
  name: 'chats',
  initialState: [],
  reducers: {
    setChats: (state, action) => {
      return action.payload;
    },
    createProjectThread: (state, action) => {
      const { chatId, threadId, projectId, fileId, vectorStoreId } = action.payload;
      const existingThread = state.find(c => c.id === chatId);
      if (!existingThread) {
        const newThread = {
          id: chatId,
          threadId: threadId,
          projectId: projectId,
          fileId: fileId,
          vectorStoreId: vectorStoreId
        }
        state.push(newThread)
      }
    },
    updateProjectThread: (state, action) => {
      const { chatId, threadId, fileId, vectorStoreId } = action.payload;
      const chat = state.find(c => c.id === chatId);
      if (chat) {
        chat.threadId = threadId;
        chat.fileId = fileId;
        chat.vectorStoreId = vectorStoreId;
      }
    },
    createTaskThread: (state, action) => {
      const { chatId, projectId, taskId, threadId } = action.payload;
      const existingThread = state.find(c => c.id === chatId);
      if (!existingThread) {
        const newThread = {
          id: chatId,
          projectId,
          taskId,
          threadId
        }
        state.push(newThread)
      }
    },
    createEmailThread: (state, action) => {
      const { chatId, emailId, mailIntegrationId, threadId } = action.payload;
      const existingThread = state.find(c => c.emailId === emailId && c.mailIntegrationId === mailIntegrationId);
      if (existingThread) {
        existingThread.id = chatId;
        if (threadId) existingThread.threadId = threadId;
      } else {
        const newThread = {
          id: chatId,
          emailId,
          mailIntegrationId,
          threadId
        }
        state.push(newThread)
      }
    },
    replaceTaskThread: (state, action) => {
      const { chatId, newThreadId } = action.payload
      const taskThread = state.find(c => c.id === chatId)
      taskThread.threadId = newThreadId
    },
    deleteThread: (state, action) => {
      const { chatId } = action.payload
      const thread = state.find(c => c.id === chatId)

      if (thread) {
        state.splice(state.indexOf(thread), 1)
      }
    },
    replaceTaskFileIds: (state, action) => {
      const { taskChatId, newFileId } = action.payload
      const taskChat = state.find(c => c.id === taskChatId)

      if (!taskChat) {
        return
      }
      taskChat.fileId = newFileId
    },
    addEmailFileId: (state, action) => {
      const { chatId, fileId, emailId, mailIntegrationId } = action.payload
      const projectChat = state.find(c => c.id === chatId)
      if (!projectChat.emailFileIds) {
        projectChat.emailFileIds = []
      }
      projectChat.emailFileIds.push({
        fileId: fileId,
        emailId: emailId,
        mailIntegrationId
      })
    },
    deleteEmailFileId: (state, action) => {
      const { chatId, fileId } = action.payload
      const projectChat = state.find(c => c.id === chatId)
      projectChat.emailFileIds = projectChat.emailFileIds.filter(file => file.fileId !== fileId)
    }
  }
})

export const { 
  createChat, 
  createProjectThread, 
  updateProjectThread,
  createTaskThread, 
  createEmailThread,
  replaceTaskThread, 
  deleteThread, 
  replaceTaskFileIds, 
  addEmailFileId,
  deleteEmailFileId
} = chatSlice.actions

export default chatSlice.reducer;
